import { Prescreen, PrescreenBody } from 'fmc-sdk';
import { assignDefined } from './util.model';
import { RtpsMockOptions } from 'fmc-sdk/src/paths/pathForRtps';
import { VirtualLookup } from 'fmc-sdk/src/api/virtualLookup';

export interface BrandRtps {
  name: RtpsName;
  address: RtpsAddress;
  location: string; // Define allowed values

  emailAddress?: string;
  mobilePhone?: string; // Need to define format
  alternativePhone?: string;
  brandDefaultStoreNumber?: string;
  customerNumber?: string;
  loyaltyNumber?: string;
  cartAmount?: string;
  checkoutAmount?: string;
  consumerInsights?: {[key: string]: string};
  productAmount?: string;
  sku?: string;
  correlationData?: string; // Not sure what data will be passed in
  cardType?: string;
  category?: string;
  country?: string;
  prescreenId?: string;

  customerAcceptedOffer?: boolean;
  channel?: string;
  subchannel?: string;
}

export interface RtpsName{
  firstName: string;
  lastName: string;
  middleInitial?: string;
}

export interface RtpsAddress{
  address1: string;
  address2?: string;
  city: string;
  state: string;
  zipCode: string;
  country: string;
}

export type FetchRtpsMockOptions =
| 'success'
| 'noHit'
| 'makeOffer'
| 'ackknowledge'
| 'existingAccount'
| 'existingOffer'
| 'newOffer'
| 'error';

export type VirtualLookupMockOptions =
  | 'success'
  | 'existingAccount'
  | 'expired'
  | 'error';

/*
* TODO add test for this function
* */
export const getPreScreenBodyFromCustomerInfo = (customerInfo: Partial<BrandRtps>,
   prescreenBody: (Partial<Prescreen> | Partial<VirtualLookup>) = {},
   urlPath = '/'): PrescreenBody => {
  let lookupData: Partial<VirtualLookup> = {};
  if(isVirtualLookup(prescreenBody)){
    lookupData = {
      firstName: prescreenBody?.firstName,
      middleInitial: prescreenBody?.middleInitial,
      lastName: prescreenBody?.lastName,
      address1: prescreenBody?.address1,
      address2: prescreenBody?.address2,
      city: prescreenBody?.city,
      state: prescreenBody?.state,
      zip: prescreenBody?.zip,
    };
  }

  return assignDefined({}, lookupData,{
    cardType: prescreenBody.cardType
  },{
    urlPath,
    firstName: customerInfo?.name?.firstName,
    middleInitial: customerInfo?.name?.middleInitial,
    lastName: customerInfo?.name?.lastName,
    address1: customerInfo?.address?.address1,
    address2: customerInfo?.address?.address2,
    city: customerInfo?.address?.city,
    state: customerInfo?.address?.state,
    zip: customerInfo?.address?.zipCode,
    country: customerInfo?.country,

    emailAddress: customerInfo?.emailAddress,
    mobilePhone: customerInfo?.mobilePhone,
    alternativePhone: customerInfo?.alternativePhone,
    cardType: customerInfo?.cardType,
    storeNumber: customerInfo?.brandDefaultStoreNumber,
    loyaltyNumber: customerInfo?.loyaltyNumber,
    customerNumber: customerInfo?.customerNumber,
    cartAmount: customerInfo?.cartAmount,
    productAmount: customerInfo?.productAmount,
    checkoutAmount: customerInfo?.checkoutAmount,
    location: customerInfo?.location,
    category: customerInfo?.category,
    sku: customerInfo?.sku,
    correlationData: customerInfo?.correlationData,

    channel: customerInfo?.channel,
    subchannel: customerInfo?.subchannel,
  });
};

export const RTPS_OVERLAY_CONTENT_ID = 'CLIENT_SIDE:rtps_overlay_v1';

export const getRtpsMockOptions =
  (mockResponse: FetchRtpsMockOptions | VirtualLookupMockOptions): RtpsMockOptions => {
  let rtpsMockOptions: RtpsMockOptions = {};
  const error = 'error';
  const success = 'success';
  const existingAccount = 'existingAccount';

  switch(mockResponse){
    case success:
      rtpsMockOptions = {
        mockVirtualLookup: success,
        mockMadeOffer: success,
        mockPrescreenAcceptance: success,
      };
      break;

    case error:
      rtpsMockOptions = {
        mockVirtualLookup: error,
        mockMadeOffer: error,
        mockPrescreenAcceptance: error,
      }
      break;

    case existingAccount:
      rtpsMockOptions = {
        mockVirtualLookup: existingAccount,
        mockMadeOffer: success,
        mockPrescreenAcceptance: existingAccount,
      };
      break;
  }
  return rtpsMockOptions;
};

export const getCleanPrescreenResult = (input: VirtualLookup): Partial<Prescreen> =>{
  const {prescreenId, result, ...passthrough} = input;
  const updatedPrescreen = {
    ...passthrough,
    prescreenId: parseInt(prescreenId, 10),
  };
  return updatedPrescreen;
};

export function isVirtualLookup(prescreenBody: (Partial<Prescreen> | Partial<VirtualLookup>)): prescreenBody is VirtualLookup{
  return (prescreenBody as VirtualLookup).firstName !== undefined;
}
